<template src="./template.html"></template>
<script>
  import _ from 'lodash';
  import fetchMaster from '@modules/vue/mixin/fetchMasterLp2';
  import {form} from 'lvgs-vue-modules';

  export default _.assign(form.fetchSelect, {
    mixins: [fetchMaster],

    mounted() {
      if (!_.isNull(this.refDefault) && !_.isUndefined(this.refDefault)) {
        this.validate = false;
        const currentValue = this.$store.getters.getValueByKey(this.refName);

        if (_.isUndefined(currentValue)) {
          this.$store.commit('setValue', {[this.refName]: this.refDefault});
        }

        this.formValue = this.refDefault;
      }

      // 他のフィールドの値の変更によってselectのmasterが変わる場合、そのフィールドを監視して、
      // 変更があったらmasterを更新する。
      if (this.hasObserveValue) {
        this.fetchMaster(this.refMaster, this.refObserveKey).then((data) => {
          this.fetchedMaster = data;
        });
      }

      if (typeof this.refObserveKey === 'string') {
        this.setWatcher(this.refObserveKey);
      } else {
        _.each(this.refObserveKey, (key) => {
          this.setWatcher(key);
        });
      }
    },
  });
</script>
